import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router';

function withRouter(Component) {
    return function ComponentWithRouterProp(props) {
        let params = useParams();
        let navigate = useNavigate();
        let location = useLocation();
        return (
            <Component
                {...props}
                router={{ params, navigate, location }}
            />
        );
    };
}

export default withRouter;
